import { RouteComponentProps, Router, useLocation } from '@reach/router';
import React, { useEffect } from 'react';
import Backdrop from '../../../../components/backdrop';
import { useTranslation } from '../../../../hooks/useTranslation';
import routes from '../../../../routes';
import { Grid } from '@material-ui/core';
import { navigate } from 'gatsby';
import theme from '../../../../themes/theme';
import { useInvoicePayment } from '../../../../hooks/invoice-payment-portal/useInvoicePayment';
import PaymentInfo from '../../../../components/invoice-payment-portal/PaymentInfo';
import PaymentVerify from '../../../../components/invoice-payment-portal/PaymentVerify';

const InvoicePaymentInfo: React.FC<RouteComponentProps<{
  invoiceId: string;
}>> = ({ invoiceId }) => {
  const {
    invoiceLoading,
    invoice,
    invoicePaymentState,
    savePaymentInfo,
    submitPayment,    
  } = useInvoicePayment(invoiceId!);

  const paymentMethodCapLimit: number = 2;

  useEffect(() => {
    // check bill
    if (!invoiceLoading && !invoice) {
      void navigate(routes.INVOICE_PAYMENT_PORTAL_INVOICE_LIST);
      return;
    }
  }, [invoiceLoading, invoice]);

  if (!invoiceLoading && !invoice) {
    //check for invoice
    return null;
  }

  return (
    <>
      {invoiceLoading && <Backdrop forceOpen />}
      {invoice && (
        <Grid
          container
          css={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(7),
          }}
        >
          <Grid item xs={10}>
            <Router basepath="/">
              <PaymentInfo
                path={routes.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_INFO}
                paymentInfo={invoicePaymentState.paymentInfo}
                invoice={invoice!}
                onSubmit={savePaymentInfo}
              />
              <PaymentVerify                
                path={routes.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_VERIFY}
                paymentInfo={invoicePaymentState.paymentInfo!}
                onSubmit={submitPayment}
                paymentMethodCapLimit={paymentMethodCapLimit}
                invoiceId={invoice?.billId!}
              />
            </Router>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default InvoicePaymentInfo;
